import {usePageResize} from "@/modules/reader/book/pageResize";

const {pageResizeState} = usePageResize();

class AbstractBuilder {

    constructor() {

    }

    setRect(rect, isContentRect) {
        this.rect = rect;
        this.domPos = this.convertToDomPos(rect, isContentRect)
        return this;
    }

    setMeta(meta) {
        this.meta = meta;
        return this;
    }

    setProtocol(protocol) {
        this.protocol = protocol;
        return this;
    }

    setPagenum(pagenum) {
        this.pagenum = pagenum;
        return this;
    }

    /**
     *  /**
     * The rect data retrieved from pdf provide left, top, bottom and right coordinate position.
     * We don't need the bottom and right, instead, width and height are used for CSS styling.
     * So, yield the left, top, width and height and they will be read for rendering.
     *
     * Important note: the pdf annotation has displacement and sizing problem, after converting from InDesign.
     * There are some pixel offsets (around 2px) at the top left corner, and the width and height are expanded relatively.
     * This method also handles these adjustments, if the annotation is contentRect type
     * @param convertToDomPos
     * @returns {{top: number, left: number, width: number, height: string}|{top: *, left: *, width: number, height: number}}
     */
    convertToDomPos(rect, isContentRect) {

        //left position should start from zero normally. if it is a negative number, get the offset (e.g. -2.2) and align it to zero.
        //set the width to the page base width if exceeded
        if (rect[0] < 0  &&  isContentRect) {

            return {
                left:0,
                top:rect[1] < 0 ? rect[1] : rect[1] - rect[0],
                width: (rect[2] > pageResizeState.baseWidth)?  pageResizeState.baseWidth : rect[2] - rect[0],
                //height:"auto"
                height:(rect[1] < 0) ? rect[3] : rect[3] - rect[1]
            }
        } else {
            return {
                left: rect[0],
                top:rect[1],
                width: rect[2] - rect[0],
                height: rect[3] - rect[1]
            }
        }

        //JP version uses this:
        /*
        return {
            left: (rect[0] < 0) ?  Math.round(rect[0] + offset) : rect[0],
            top: (rect[1] < 0) ?  Math.round(rect[1] + offset) : rect[1],
            width: (rect[0] < 0) ? Math.round(rect[2] - offset ) : rect[2] - rect[0],
            height:(rect[1] < 0) ? Math.round(rect[3] - offset ) : rect[3] - rect[1],
        }*/
    }

}

export default AbstractBuilder

